const retrieveSquadNo = groups => {
    for (const group of groups) {
        if (group.includes('Squad')) {
            return parseInt(group.match(/\d+/)[0], 10)
        }
    }
    return null
}

const retrieveSquadNoArray = groups => {
    const squadsArray = []
    for (const group of groups) {
        if (group.includes('Squad')) {
            squadsArray.push(retrieveSquadNo([group]))
        }
    }
    return squadsArray
}

 const  getKalviumSupportedSquads =() => {
  const squads = import.meta.env.VITE_KALVIUM_SUPPORT_V3_SQUADS
    ? import.meta.env.VITE_KALVIUM_SUPPORT_V3_SQUADS.split(',').map(s => s.trim()).filter(s => s.length > 0)
    : []
  return squads
}

const isSupportV3Enabled = (squad) => {
    const kalviumSupportedSquads = getKalviumSupportedSquads()
    return kalviumSupportedSquads.includes(squad) || kalviumSupportedSquads.includes("all")
}


export { retrieveSquadNo, retrieveSquadNoArray , isSupportV3Enabled }
